export default __webpack_public_path__ + "static/media/opus-logo.657e2ee3.svg";